module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_0@2x.c47c2ce0.png";